import TimeWithRegionalFormat from "@DateTime/components/TimeWithRegionalFormat";
import CompanyLogo from "@Route/features/company/components/CompanyLogo";
import React from "react";
import formatDate from "@DateTime/functions/formatDate";
import StationWithDateTimesType from "@SearchResults/types/station/StationWithDateTimes.type";

type TripDetailsProps = {
    departureStation: StationWithDateTimesType,
    destinationStation: StationWithDateTimesType,
    logoUrl: string,
    companyId: string,
}

function TripDetails({departureStation, destinationStation, logoUrl, companyId}: TripDetailsProps) {
    const dateFormat = "E, MMM dd"
    const dateLabel = formatDate(departureStation.departureDate, dateFormat, true)

    return (
        <>
            <span className="gb--emphasize">
                <span>
                    {`${dateLabel} `}
                </span>
                <TimeWithRegionalFormat
                    time={departureStation.departureTime}
                />
                <span> - </span>
                <TimeWithRegionalFormat
                    time={destinationStation.arrivalTime}
                />
            </span>
            <span>
                <small>{`${departureStation?.apiStationName ?? departureStation.name}`}</small>
                <small> - </small>
                <small>{`${destinationStation?.apiStationName ?? destinationStation.name}`}</small>
            </span>
            <div className="search-results_main-content" style={{paddingTop: '1rem'}}>
                <CompanyLogo
                    companyId={companyId}
                    logoUrl={logoUrl}
                />
            </div>
        </>
    );
}

export default TripDetails;